import { ITableCellTag } from '@/components/common/Table/Table.interfaces';
import { RoleStatus } from '@/features/role-assignments/enums';

export const getRoleStatusLabel = (status: RoleStatus): string => {
  switch (status) {
    case RoleStatus.Active:
      return 'Active';
    case RoleStatus.Inactive:
      return 'Inactive';
  }
};

export const getRoleStatusVariant = (status: RoleStatus): ITableCellTag['tagVariant'] => {
  switch (status) {
    case RoleStatus.Active:
      return 'active';
    case RoleStatus.Inactive:
      return 'inactive';
    default:
      return 'default';
  }
};
